import { defineMessages } from 'react-intl';

export default defineMessages({
  title: {
    id: 'frontbucket.pullRequest.hiddenFileDialog.title',
    description:
      'Title of the dialog shown when attempting to navigate to a hidden file.',
    defaultMessage: 'Filters will be cleared',
  },
  body: {
    id: 'frontbucket.pullRequest.hiddenFileDialog.body',
    description:
      'Dialog message when attempting to view a file hidden due to comment filters.',
    defaultMessage:
      'The file you selected cannot be displayed because of the filters you have set. Navigating to this file will clear your filters.',
  },
  confirm: {
    id: 'frontbucket.pullRequest.hiddenFileDialog.confirm',
    description:
      'Confirm button text on the dialog shown when navigating to a hidden file',
    defaultMessage: 'Go to file',
  },
  cancel: {
    id: 'frontbucket.pullRequest.hiddenFileDialog.cancel',
    description:
      'Cancel button text on the dialog shown when navigating to a hidden file',
    defaultMessage: 'No thanks',
  },
});
